import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { paths } from 'src/routes/paths';

import { useEntityContext } from 'src/entity/hooks';

import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useTranslation();
  const { entity_id, parent_entity_id } = useEntityContext();

  const navData = useMemo(
    () => [
      {
        subheader: '',
        items: [
          {
            title: t('nav.menu.diag_ref.dashboard'),
            path: paths.entity.modules.diag_ref.dashboard.root(parent_entity_id || entity_id),
            icon: <Iconify icon="material-symbols:dashboard-outline" />,
          },
          {
            title: t('nav.menu.diag_ref.diagnostiques'),
            path: paths.entity.modules.diag_ref.diagnostiques(parent_entity_id || entity_id),
            icon: <Iconify icon="material-symbols:list-alt-outline" />,
          },
        ],
      },
    ],
    [t, entity_id, parent_entity_id]
  );

  return navData;
}
